module.exports = __webpack_public_path__ + "static/media/Video-Homily-Notes.6b91dd4b.pdf";